




























































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../lib/util";
import appconst from "../lib/appconst";
import AbpBase from "../lib/abpbase";
import Ajax from "../lib/ajax";

interface IRequestParams {
    pictureType: string;
}

interface UploadImage {
    imageUrl: string;
    linkUrl: string;
    alt: string;
    displayOrder: number;
}

@Component({
    components: {}
})
export default class MultiPicture extends AbpBase {
    @Prop({
        type: Array,
        default: () => {
            return [];
        }
    })
    value: Array<any>;

    @Prop({ type: Object }) requestData: IRequestParams;

    @Prop({ type: Object }) extendData: any;

    uploadList: Array<any> = new Array<any>();

    fileList: Array<any> = new Array<any>();

    visible: boolean = false;

    uploadUrl: string = appconst.appBaseUrl + "Picture/UploadPicture";

    imageUrl = "";

    absUrl(url) {
        return appconst.remoteServiceBaseUrl + url;
    }

    handleView(file) {
        this.imageUrl = appconst.remoteServiceBaseUrl + file.imageUrl;
        this.visible = true;
    }
    handleRemove(file) {
        // TODO: 删除图片
        let deleteUrl =
            appconst.appBaseUrl +
            "Picture/DeletePicture?PictureUrl=" +
            file.imageUrl;
        Ajax.get(deleteUrl)
            .then(() => {
                const fileList = this.uploadList;
                fileList.splice(fileList.indexOf(file), 1);
                this.$emit("input", this.uploadList);
                if (file.id) {
                    this.$emit('on-delete-success',file.id);
                }
            })
            .catch(() => {
                this.$Message.error("删除图片失败");
            });
    }
    handleSuccess(res, file) {
        //file.url = appconst.remoteServiceBaseUrl + res.result.url;
        //this.value = res.result.url;

        this.uploadList.push({
            imageUrl: res.result.url,
            linkUrl: "",
            alt: "",
            displayOrder: this.uploadList.length + 1,
            ...this.extendData
        });

        this.$emit("input", this.uploadList);
    }
    handleBeforeUpload() {
        if (!!window.abp.auth.getToken()) {
            (this.$refs.upload as any).headers["Authorization"] =
                "Bearer " + window.abp.auth.getToken();
        }
        (this.$refs.upload as any).headers[
            ".AspNetCore.Culture"
        ] = window.abp.utils.getCookieValue("Abp.Localization.CultureName");
        (this.$refs.upload as any).headers[
            "Abp.TenantId"
        ] = window.abp.multiTenancy.getTenantIdCookie();
    }
    mounted() {
        this.fileList = (this.$refs.upload as any).fileList;
    }
    created() {}
    @Watch("value")
    onValueChange(val: any, oldVal: any) {
        if (val[0]) {
            this.uploadList = val;
        }
        else {
            this.uploadList = [];
        }
    }
}
